var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDomainRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_430_732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.391 16.7997L0.5 19.7197L3 20.2197L2.5 22.7197C2.5 22.7197 6.5 21.2197 6.5 19.2197C6.5 17.2197 3 16.7197 3 15.2197",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5C5.80037 8.8611 4.63833 9.33697 3.53 9.921C3.37047 10.0059 3.23694 10.1325 3.14362 10.2873C3.0503 10.4421 3.00066 10.6193 3 10.8V15.217C5.74223 13.6406 8.83757 12.7807 12 12.717C15.1624 12.7807 18.2578 13.6406 21 15.217V10.8C21.0002 10.6187 20.951 10.4407 20.8578 10.2852C20.7647 10.1297 20.6309 10.0024 20.471 9.917C19.376 9.33998 18.2289 8.86788 17.045 8.507",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19.2212V13.6572",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.606 16.7997L23.5 19.7197L21 20.2197L21.5 22.7197C21.5 22.7197 17.5 21.2197 17.5 19.2197C17.5 17.2197 21 16.7197 21 15.2197",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19.2212V13.6572",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8626 1.47827C11.9386 1.21427 12.0626 1.21427 12.1376 1.47827L12.9996 4.50027H16.4996C16.7746 4.50027 16.8266 4.64427 16.6156 4.82027L13.9996 7.00027L15.3236 10.5323C15.4236 10.7903 15.3156 10.8683 15.0926 10.7103L11.9996 8.50027L8.90657 10.7063C8.68257 10.8653 8.57857 10.7863 8.67557 10.5283L9.99958 7.00027L7.38358 4.81727C7.17258 4.64127 7.22458 4.49727 7.49958 4.49727H10.9996L11.8626 1.47827Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_430_732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainRank);
export default __webpack_public_path__ + "static/media/domain-rank.b884c023e1564ac5c14ac3eb951ebe65.svg";
export { ForwardRef as ReactComponent };